module.exports = __webpack_public_path__ + "media/night/305-3c3228a1.svg";